import React, { useRef, useState, useEffect } from 'react';
import { connect } from 'react-redux';
import M from 'materialize-css/dist/js/materialize';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { BackButton, Collapsible, List } from '../../../../../components/UI/ComponentsUI';
import LoweringService from '../../../../../services/LoweringService';
import * as actionsLowering from '../../../../../actions/loweringAction';
import { ENUMS, PERMISSIONS, VISIONS } from '../../../../../utils/constants';
import { formatData, isNullOrEmpty, showMessageToastCustom, translate } from '../../../../../utils/util';
import useStateWithPromise from "../../../../../utils/useEffectUpdate";
import ConfirmModalRepicking from './ConfirmModalRepicking';
import { checkPermission, getVision } from '../../../../../services/auth';
import RoutePickingService from '../../../../../services/RoutePickingService';
import DeliveryService from '../../../../../services/DeliveryService';
import { onValueChange } from '../../../../../utils/handleChangeHooks';
import ConfirmModalUI from '../../../../../components/UI/ConfirmModalUI';

const ListItemMissionDetail = (props) => {
    const inputCIM = useRef();
    const messageModalRepicking = useRef();
    const messageModalRepickingGrouped = useRef();
    const [orders, setOrdes] = useState([]);
    const [openModal, setOpenModal] = useState(false);
    const [openModalMasterCim, setOpenModalMasterCim] = useState(false);
    const [refreshed, setRefreshed] = useState(false);
    const [modelMessage, setModelMessage] = useStateWithPromise({
        title: '',
        message: '',
        confirm: '',
        mission: '',
        leave: false
    });
    const [model, setModel] = useStateWithPromise({
        cim: '',
        totalItems: '',
        collected: 0
    });
    const [showButtonLeave, setShowButtonLeave] = useState(false);
    const [showButtonRepicking, setShowButtonRepicking] = useState(false);
    const [buttonCount, setButtonCount] = useState(3);

    const refreshComponent = () => {
        setRefreshed(!refreshed);
    }

    const onChange = (event) => {
        onValueChange(event, model, setModel);
    };

    useEffect(() => {
        if ((getVision() === VISIONS.Fiasa || getVision() === VISIONS.Faasa || getVision() === VISIONS.FaasaCKD)) {
            props.getRoutes();
        }

        document.addEventListener('message', msgHandler);
        M.updateTextFields();

        if (getVision() !== VISIONS.Fiasa && getVision() !== VISIONS.Faasa && getVision() !== VISIONS.FaasaCKD) {
            inputCIM.current.focus();
        }
        verifyStartGrouped(props.order);
        totalItems();

        document.addEventListener('linePickingRefreshMission', refreshComponent);

        return () => {
            if (props.location.callback) {
                props.location.callback();
            }
            document.removeEventListener('message', msgHandler);
            document.removeEventListener('linePickingRefreshMission', refreshComponent);
        }
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if ((getVision() !== VISIONS.Fiasa && getVision() !== VISIONS.Faasa && getVision() !== VISIONS.FaasaCKD)) {
            inputCIM.current.focus();
            totalItems();
            if (refreshed && props.orders.filter((o) => o.orderId === props.mission.orderId).length === 0) {
                getNextMission(null, () => totalItems());
            }
            setRefreshed(false);
        }

        if (props.orders?.items) {
            const pendingList = props.orders.items.filter((m) =>
                (m.status === ENUMS.eOrderStatus.Waiting.value || m.status === ENUMS.eOrderStatus.InProgress.value)
                && m.items.filter((i) => i.status === ENUMS.eOrderItemStatus.Waiting.value || i.status === ENUMS.eOrderItemStatus.InProgress.value).length > 0
                && m.orderId !== props.mission.orderId);
            setOrdes(pendingList);
        }
        // eslint-disable-next-line
    }, [props.mission, refreshed]);

    // Exibir os botoes da tela de acordo com as permissoes/visao do usuario:
    useEffect(() => {
        let btCount = 1; // Bt Confirmar

        if (getVision() !== VISIONS.Fiasa && getVision() !== VISIONS.Faasa && getVision() !== VISIONS.FaasaCKD &&
            (props.groupOrder?.orders?.length > 0 || props.orders?.length > 0 || props.orders?.items?.length > 0)) {
            setShowButtonLeave(true);
            btCount += 1;
        }

        if (checkPermission(PERMISSIONS.Lowering.Repicking) || getVision() === VISIONS.Jeep) {
            setShowButtonRepicking(true);
            btCount += 1;
        }

        setButtonCount(btCount);
        // eslint-disable-next-line
    }, [props.groupOrder?.orders, props.orders, props.orders?.items]);


    const msgHandler = (e) => {
        if (e.data.length === 10) {
            if (props.mission.cim !== e.data) {
                showMessageToastCustom(translate('general:warning'), translate('line-picking:CIM-incorret'), 3000, 'mdi mdi-alert-circle-outline red-text');
            } else {
                setModel({ ...model }).then(() => {
                    M.updateTextFields();
                    submit();
                });
            }
        }
    }

    const isValidForm = () => {
        if (getVision() !== VISIONS.Fiasa && getVision() !== VISIONS.Faasa && getVision() !== VISIONS.FaasaCKD) {
            if (isNullOrEmpty(model.cim)) {
                showMessageToastCustom(translate('general:warning'), translate('line-picking:linepicking.CIM-not-informed'), 3000, 'mdi mdi-alert-circle-outline red-text');
                return false;
            } else if (model.cim !== props.mission.cim && model.cim !== props.mission.partnumber
                && model.cim !== props.mission.location && model.cim !== props.mission.cimSupplier) {
                showMessageToastCustom(translate('general:warning'), translate('line-picking:linepicking.CIM-incorret'), 3000, 'mdi mdi-alert-circle-outline red-text');
                return false;
            }
        }
        return true;
    }

    const getNextMission = (orderId, callback) => {
        if (props.orders?.items && props.groupOrder?.orderGroupId > 0 &&
            (getVision() !== VISIONS.Fiasa && getVision() !== VISIONS.Faasa && getVision() !== VISIONS.FaasaCKD)) {
            const pendingList = props.orders.items.filter((m) => (m.status === ENUMS.eOrderStatus.Waiting.value || m.status === ENUMS.eOrderStatus.InProgress.value)
                && (isNullOrEmpty(orderId) ? m.orderId !== props.order.orderId : m.orderId === orderId)
                && m.items.filter((i) => i.status === ENUMS.eOrderItemStatus.Waiting.value || i.status === ENUMS.eOrderItemStatus.InProgress.value).length > 0);

            if (pendingList.length > 0) {
                const itemsPending = pendingList[0].items.filter((i) => i.status === ENUMS.eOrderItemStatus.Waiting.value || i.status === ENUMS.eOrderItemStatus.InProgress.value);
                if (itemsPending.length > 0) {
                    const messageDefault = translate('line-picking:linepicking.confirm-order-item-start');
                    showMessageModal(translate('validations:attention'),
                        messageDefault.replace('{location}', itemsPending[0].location).replace('{orderCode}', pendingList[0].orderCode),
                        itemsPending[0], 'nextMission', false);
                    if (callback) {
                        callback();
                    }
                }
                else {
                    redirectFinalize(false);
                }
            }
            else {
                redirectFinalize(false);
            }
        } else {
            redirectFinalize(false);
        }
    }

    const redirectFinalize = (leave) => {
        if ((getVision() === VISIONS.Fiasa || getVision() === VISIONS.Faasa || getVision() === VISIONS.FaasaCKD) && props.groupOrder?.orderGroupId > 0 && !props.orderReceived.noHasGroup) {
            return props.history.push('/lowering/smallParts/orders/missions/list');
        }

        return props.groupOrder?.orderGroupId > 0 ? onFinalize()
            : props.history.go(-1);
    }

    const verifyStartGrouped = (order) => {
        if (order.grouped) {
            var orders = props.orders.items.filter((m) => order.orderIdGrouped.includes(m.orderId));
            orders.forEach((o, index) => {
                var orderItem = o.items[0];
                if (index === 0) {
                    props.setSelectedOrder(o);
                }
                if (o.status === ENUMS.eOrderStatus.Waiting.value) {
                    props.startOrder(o.orderId);
                }
                if (orderItem.status === ENUMS.eOrderItemStatus.Waiting.value) {
                    props.startOrderItem(o.orderId, orderItem.orderItemId);
                }
                if (index === 0) {
                    props.setSelectedMission(orderItem);
                }
            });
            return true;
        }
        return false;
    }


    const confirmGrouped = (orders, justificationId, callback) => {
        var aux = 0;
        orders.forEach((o) => {
            var orderItem = o.items[0];
            if (aux < model.collected) {
                props.setSelectedOrder(o);
                props.setSelectedMission(orderItem);
                props.updateMissionStatus(orderItem.orderItemId, ENUMS.eOrderItemStatus.Finished.value);
                props.updateOrderStatus(orderItem.orderId, ENUMS.eOrderStatus.WaitingFinish.value);

                aux = aux + 1;
                console.log("Picking Grupo", orderItem);
                props.confirmPicking(orderItem, () => {
                    if (aux === orders.length && callback) {
                        callback();
                    }
                });
            }
            else {
                //dar repicking dos faltantes
                orderItem.justificationId = justificationId;
                props.setSelectedOrder(o);
                props.setSelectedMission(orderItem);
                props.updateMissionStatus(orderItem.orderItemId, ENUMS.eOrderItemStatus.Finished.value);
                props.updateOrderStatus(orderItem.orderId, ENUMS.eOrderStatus.WaitingFinish.value);
                aux = aux + 1;
                console.log("Repicking Grupo", orderItem);
                props.rePicking(orderItem, props.areas, () => {
                    if (aux === orders.length && callback) {
                        callback();
                    }
                });
            }
        });
    }

    const repickingGrouped = (item) => {
        var orders = props.orders.items.filter((m) => props.order.orderIdGrouped.includes(m.orderId));
        confirmGrouped(orders, item.justification, callbackSubmit);
    }


    const callbackSubmit = (orderId) => {
        getNextMission(orderId, () => totalItems());

        if (getVision() !== VISIONS.Fiasa && getVision() !== VISIONS.Faasa && getVision() !== VISIONS.FaasaCKD) {
            inputCIM.current.value = '';
            setModel({ ...model });
        }
    }

    const submit = (masterCim) => {
        if (isValidForm()) {
            props.updateMissionStatus(props.mission.orderItemId, ENUMS.eOrderItemStatus.Finished.value);
            props.updateOrderStatus(props.mission.orderId, ENUMS.eOrderStatus.WaitingFinish.value);
            props.confirmPicking({ ...props.mission, confirmMasterCim: masterCim }, callbackSubmit);
        }

    }

    const confirmAlertRepicking = () => {
        setOpenModal(true);
    }

    const confirmRepicking = () => {
        showMessageModal(translate('validations:attention'), translate('expedition:picking.confirm-rePicking'),
            null, 'repicking', false);
    }

    const onFinalize = () => {
        props.finalize({ orderGroupId: props.groupOrder?.orderGroupId }, () => {
            if (getVision() !== VISIONS.Fiasa) {
                props.history.replace({
                    pathname: '../../../smallparts/filter',
                });
            }
            else {
                props.history.replace({
                    pathname: '../../../smallparts',
                    state: {
                        route: '../smallParts/onDemand',
                        title: { icon: 'mdi mdi-cart-outline', label: translate('menu.lowering', 'configuration') },
                        subtitle: { icon: "compare_arrows", label: translate('expedition:picking.ondemand') }
                    }
                });
            }
            return;
        });
    }

    const confirm = () => {
        if (modelMessage.confirm === 'nextMission') {
            if (getVision() === VISIONS.Fiasa || getVision() === VISIONS.Faasa || getVision() === VISIONS.FaasaCKD) {
                return props.history.go(-1);
            }
            var order = props.orders?.items ?
                props.orders.items.find(o => o.orderId === modelMessage.mission.orderId) :
                props.orders.find(o => o.orderId === modelMessage.mission.orderId);


            props.setSelectedOrder(order);
            props.startOrder(order.orderId);
            if (modelMessage.mission.status === ENUMS.eOrderItemStatus.Waiting.value) {
                props.startOrderItem(modelMessage.mission.orderId, modelMessage.mission.orderItemId, () => {
                    props.setSelectedMission(modelMessage.mission);
                });

            } else {
                order = props.orders?.items?.find(o => o.orderId === modelMessage.mission.orderId);
                props.setSelectedOrder(order);
                props.startOrder(order.orderId);
                props.setSelectedMission(modelMessage.mission);
            }

        }
    }

    const repicking = (item) => {
        if (props.order.grouped) {
            model.collected = 0;
            setModel({ ...model }).then((n) => {
                M.updateTextFields();
                repickingGrouped(item);
            });
        } else {
            props.mission.justificationId = item.justification;
            props.rePicking(props.mission, props.areas, () => {
                getNextMission(null, () => {
                    props.history.replace({
                        pathname: `./${props.mission.orderItemId}`
                    });
                    totalItems();
                });
            });
        }
    }

    const leave = (abandon) => {
        if (props.groupOrder?.orderGroupId > 0) {
            const totalWaiting = props.groupOrder.orders.filter((i) =>
                i.status === ENUMS.eOrderStatus.Finished.value
                || i.status === ENUMS.eOrderStatus.ManuallyFinished.value
                || i.status === ENUMS.eOrderStatus.WaitingFinish.value).length;

            if (totalWaiting > 0 && abandon) {
                redirectFinalize(true);
            } else if (getVision() === VISIONS.Fiasa || getVision() === VISIONS.Faasa || getVision() === VISIONS.FaasaCKD) {
                props.history.go(-1);
            }
            else {
                props.leave(props.groupOrder.orderGroupId, abandon, () => {
                    props.history.go(-1);
                });
            }
        } else {
            if (getVision() === VISIONS.Jeep) {
                props.unblockOrder(props.order.orderId, () => props.history.go(-1));
            }
            else {
                props.history.go(-1);
            }
        }
    }

    const showMessageModal = (title, message, mission, confirmMessage, leave) => {
        const auxModel = modelMessage;
        auxModel.title = title;
        auxModel.message = message;
        auxModel.mission = mission;
        auxModel.confirm = confirmMessage;
        auxModel.leave = leave;
        setModelMessage({ ...auxModel }).then((n) => {
            if (confirmMessage === 'repicking') {
                messageModalRepicking.current.show();
            } else if (confirmMessage === 'confirmGrouped') {
                messageModalRepickingGrouped.current.show();
            }
            else {
                return confirm();
            }
        });
    }

    const scanner = () => {
        if (navigator.userAgent === 'logisticspwa') {
            const content = window.ReactNativeWebView;
            content.postMessage('exibirTela');
        } else {
            showMessageToastCustom(translate('general:warning'), translate('validations:service-not-available'), 3000, 'mdi mdi-alert-circle-outline red-text');
        }
    }

    const getCodeRouteIdOrigem = (idRouteOrigem) => {
        if (!isNullOrEmpty(idRouteOrigem)) {
            return props.routes?.items ? props.routes?.items.find(x => x.id === idRouteOrigem)?.code : '';
        }
        return '';
    }

    const totalItems = () => {
        if (!props.orders) {
            return '';
        }
        if (props.groupOrder.orders) {
            const total = props.groupOrder.orders.filter((i) => i.items?.filter((m) => m.status !== ENUMS.eOrderItemStatus.WaitingRepicking.value).length > 0).length;
            const totalWaiting = props.groupOrder.orders.filter((i) =>
                i.status === ENUMS.eOrderStatus.Finished.value
                || i.status === ENUMS.eOrderStatus.ManuallyFinished.value
                || i.status === ENUMS.eOrderStatus.WaitingFinish.value
                || i.status === ENUMS.eOrderStatus.NotFound.value).length;

            const totalLabel = `${(totalWaiting)}/${total}`;
            model.totalItems = totalLabel;
            setModel({ ...model }).then(() => { M.updateTextFields(); });
        }
        else if (props.order.items) {
            const total = props.order.items.filter((m) => m.status !== ENUMS.eOrderItemStatus.WaitingRepicking.value).length;
            const totalWaiting = props.order.items.filter((i) => i.status === ENUMS.eOrderItemStatus.Finished.value || i.status === ENUMS.eOrderItemStatus.NotFound.value).length;
            const totalLabel = `${(total - totalWaiting)}/${total}`;
            model.totalItems = totalLabel;
            setModel({ ...model }).then(() => { M.updateTextFields(); });
        }
    };

    return (
        <div>
            <BackButton {...props} onClick={() => leave(false)} />
            <div className="container-fluid h-65">
                <div className="row">
                    <div className="title">
                        <i className="mdi mdi-camera-timer" />
                        {translate('menu.lowering', 'configuration')}
                    </div>
                    <div className="subtitle">
                        <i className="material-icons">playlist_add_check</i>
                        {translate('expedition:picking.missions')}
                    </div>
                </div>
            </div>
            <div className="container" style={{ marginTop: '35px', }}>
                <div className="col s4 subtitle">
                    <span style={{ display: 'inline-flex' }}>
                        {translate('line-picking:linepicking.status')} : {model.totalItems}
                    </span>
                </div>
                <div className="col s8 subtitle">
                    <span style={{ display: 'inline-flex' }}>
                        {translate('line-picking:linepicking.route')} : {props.order?.route?.code || ''}
                    </span>
                </div>
                {props.order?.routeIdOrigem &&
                    <div className="col s8 subtitle">
                        <span style={{ display: 'inline-flex' }}>
                            {translate('line-picking:linepicking.routeOrigin')} : {getCodeRouteIdOrigem(props.order?.routeIdOrigem) || ''}
                        </span>
                    </div>
                }
                <div className="card">
                    <div className="card-content" style={{ padding: '4px' }}>
                        <form>
                            <div className="row" style={{ marginBottom: '0' }}>
                                {
                                    (getVision() === VISIONS.Fiasa || getVision() === VISIONS.Faasa || getVision() === VISIONS.FaasaCKD) && (
                                        <div className="input-field no-padding col s6  mb-8" style={{ marginRight: '0' }} >
                                            <span className="field f-1p45r">{props.mission?.orderItemCode}</span>
                                            <label className="active" htmlFor="cim">{translate('line-picking:linepicking.requisition')}</label>
                                        </div>
                                    )
                                }
                                <div className="input-field no-padding col s6  mb-8" style={{ marginRight: '0' }} >
                                    <span className="field f-1p45r">
                                        {(getVision() !== VISIONS.Fiasa && getVision() !== VISIONS.Faasa && getVision() !== VISIONS.FaasaCKD)
                                            ? props.mission?.cim : props.mission?.auxCode}
                                    </span>
                                    <label className="active" htmlFor="cim">{translate('line-picking:linepicking.CIM')}</label>
                                </div>
                                <div className="input-field no-padding col s3  mb-8" style={{ marginRight: '0' }}>
                                    <span className="field f-1p45r">{props.mission?.partnumber}</span>
                                    <label className="active" htmlFor="partnumber">{translate('expedition:picking.partnumber')}</label>
                                </div>
                                <div className="input-field no-padding col s6 mb-8 truncate" style={{ marginRight: '0' }}>
                                    <span className="field f-1r">{props.mission?.description}</span>
                                    <label className="active" htmlFor="description">{translate('expedition:picking.description')}</label>
                                </div>
                                {
                                    props.order.grouped === false &&
                                    <div className="input-field no-padding col s6 mb-8" style={{ marginRight: '0' }}>
                                        <span className="field f-1r">{props.order?.orderCode}</span>
                                        <label className="active" htmlFor="ordercode">{translate('expedition:picking.orderCode')}</label>
                                    </div>

                                }
                                <div className="input-field no-padding col s6 mb-8" style={{ marginRight: '0' }}>
                                    <span className="field f-1r" style={{ fontWeight: 'bold' }}>{props.mission?.location}</span>
                                    <label className="active" htmlFor="location"  >{translate('expedition:picking.location')}</label>
                                </div>
                                <div className="input-field no-padding col s6 mb-8" style={{ marginRight: '0' }}>
                                    <span className="field f-1r">{props.order.grouped ? props.order.orderIdGrouped.length : props.mission?.quantity}</span>
                                    <label className="active" htmlFor="quantity">{props.order.grouped ? translate('line-picking:linepicking.quantityTd') : translate('expedition:picking.quantity')}</label>
                                </div>
                                <div className="input-field no-padding col s6 mb-8" style={{ marginRight: '0' }}>
                                    <span className="field f-1r">{props.mission?.mdrType}</span>
                                    <label className="active" htmlFor="productId">{translate('expedition:picking.mdrType')}</label>
                                </div>
                                <div className="input-field no-padding col s6 mb-8" style={{ marginRight: '0' }}>
                                    <span className="field f-1r">{props.mission?.nextLocation}</span>
                                    <label className="active" htmlFor="pdu">PDU</label>
                                </div>
                                {!isNullOrEmpty(props.mission?.allocationDate) &&
                                    <div className="input-field no-padding col s6  mb-8" style={{ marginRight: '0' }}>
                                        <span className="field f-1r">{formatData(props.mission?.allocationDate)}</span>
                                        <label className="active" htmlFor="allocationDate">{translate('expedition:picking.allocationDate')}</label>
                                    </div>
                                }
                                {(getVision() === VISIONS.Jeep && props.order.grouped && props.order.orderIdGrouped.length > 0) && (
                                    <div className="input-field no-padding col s3 mb-8" style={{ marginRight: '0' }}>
                                        <span className="field f-1r">{props.mission?.quantity}</span>
                                        <label className="active" htmlFor="quantity">{translate('expedition:picking.cimQuantity')}</label>
                                    </div>
                                )}

                                {(getVision() === VISIONS.Fiasa || getVision() === VISIONS.Faasa || getVision() === VISIONS.FaasaCKD) && (
                                    <div className="input-field no-padding col s3 mb-8" style={{ marginRight: '0' }}>
                                        <span className="field f-1r">{props.mission?.partial ? translate('line-picking:linepicking.yes') : translate('line-picking:linepicking.no')}</span>
                                        <label className="active" htmlFor="productId">{translate('line-picking:linepicking.partial')}</label>
                                    </div>

                                )}
                                {(getVision() !== VISIONS.Fiasa && getVision() !== VISIONS.Faasa && getVision() !== VISIONS.FaasaCKD) && (
                                    <div className="input-field no-padding col s12" style={{ marginTop: '3' }}>
                                        <input
                                            id="cim"
                                            name="cim"
                                            ref={inputCIM}
                                            type="text"
                                            onChange={onChange}
                                            onBlur={onChange}
                                            defaultValue={model.cim}
                                        />
                                        <label className="required" htmlFor="cim">{translate('line-picking:linepicking.CIM')}</label>
                                        <i className="material-icons posfix" onClick={scanner.bind(this)}> camera_alt</i>
                                    </div>
                                )}
                            </div>
                            <div className="row" style={{ paddingTop: '8px' }}>
                                {
                                    showButtonLeave &&
                                    <button
                                        type="button"
                                        onClick={() => leave(true)}
                                        className={`col s${12 / buttonCount}
                                                            btn
                                                            btn-gray
                                                            waves-effect
                                                            waves-light
                                                            btn-flat`}
                                    >
                                        {translate('line-picking:linepicking.leave')}
                                    </button>
                                }
                                {
                                    showButtonRepicking &&
                                    <button
                                        type="button"
                                        onClick={() => {
                                            if (getVision() === VISIONS.Fiasa) {
                                                confirmAlertRepicking();
                                            } else {
                                                confirmRepicking();
                                            }
                                        }}
                                        className={`col s${12 / buttonCount}
                                                    btn
                                                    waves-effect
                                                    waves-light
                                                    btn-flat`}
                                    >
                                        {translate('expedition:picking.repicking')}
                                    </button>
                                }
                                <button
                                    type="button"
                                    className={`col s${12 / buttonCount}
                                        btn
                                        btn-principal
                                        waves-effect
                                        waves-light `}
                                    onClick={() => {
                                        if (!isNullOrEmpty(props.mission.masterCim && getVision() === VISIONS.Fiasa)) {
                                            setOpenModalMasterCim(true);
                                        } else {
                                            submit()
                                        }
                                    }
                                    }                                >
                                    {translate('general:confirm')}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
                {
                    getVision() === VISIONS.Jeep && props.groupOrder?.orderGroupId > 0 && orders.length > 0 &&
                    <Collapsible
                        id="orderFilterGroup"
                        header={translate('expedition:picking.missions')}
                        body={
                            <List
                                data={orders.map((item) => (
                                    <div
                                        className="row"
                                        style={{ backgroundColor: 'white', color: 'black', display: 'block', marginBottom: '0px', marginLeft: '0px' }}
                                        onClick={() => {
                                            callbackSubmit(item.orderId);
                                        }}
                                    >
                                        <div className="col s12" style={{ padding: '0px', fontWeight: 'bold' }}>
                                            {`${translate('expedition:picking.partnumber')}: ${item?.items[0]?.partnumber || ''}`}
                                        </div>
                                        <div className="truncate col s12" style={{ padding: '0px' }}>
                                            {`Descrição: ${item?.items[0]?.description}`}
                                        </div>
                                        <div className="col s12" style={{ padding: '0px' }}>
                                            {`${translate('line-picking:linepicking.location')}: ${item?.items[0]?.location || ''}`}
                                        </div>
                                        <div className="col s6" style={{ padding: '0px' }}>
                                            {`CIM: ${item?.items[0]?.cim || ''}`}
                                        </div>
                                        <div className="col s5" style={{ padding: '0px' }}>
                                            {`Qtd: ${item?.items[0]?.quantity || ''}`}
                                        </div>
                                    </div>
                                ))}
                            />
                        }
                    />
                }
            </div >
            {/* <ConfirmModalFinalize
                ref={messageModalFinalize}
                dismissible={false}
                groupOrder={props.groupOrder}
                id="messageModalFinalize"
                data={{ title: modelMessage.title, message: modelMessage.message }}
                onAdd={confirmModal}
                onFinalize={onFinalize}
                btnAdd={translate('general:add')}
                leave={modelMessage.leave}
                btnFinalize={translate('general:finalize')}
            /> */}
            <ConfirmModalRepicking
                ref={messageModalRepicking}
                id="confirmModalRepicking"
                dismissible={false}
                data={{ title: modelMessage.title, message: modelMessage.message }}
                onConfirm={repicking}
                btnCancel={translate('general:cancel')}
                btnConfirm={translate('general:confirm')}
                justifications={props.justifications}
            />
            <ConfirmModalRepicking
                ref={messageModalRepickingGrouped}
                id="confirmModalRepickingGrouped"
                dismissible={false}
                data={{ title: modelMessage.title, message: modelMessage.message }}
                onConfirm={repickingGrouped}
                btnCancel={translate('general:cancel')}
                btnConfirm={translate('general:confirm')}
                justifications={props.justifications}
            />
            <ConfirmModalUI
                open={openModal}
                id="messageAlertRepicking"
                data={{
                    title: `${translate('validations:attention')} ${translate('expedition:picking.repicking')}`,
                    message: <>
                        <span className="title col s12" style={{ color: 'red' }}>{
                            translate('line-picking:linepicking.alert-repicking')}</span>
                    </>
                }}
                onConfirm={() => {
                    setOpenModal(false)
                    confirmRepicking()
                }}
                onCancel={() => setOpenModal(false)}
                onClose={() => setOpenModal(false)}
                btnCancel={translate('cancel', 'general')}
                btnConfirm={translate('confirm', 'general')}
            />
            <ConfirmModalUI
                open={openModalMasterCim}
                id="messageConfirmMasterCim"
                data={{
                    title: `${translate('validations:attention')}`,
                    message: <>
                        <span className="title col s12">{`${translate('line-picking:linepicking.confirm-order-mastercim').replace('{cim}', props.mission.cim).replace('{masterCim}', props.mission?.masterCim)}`}</span>
                    </>
                }}
                onConfirm={() => {
                    setOpenModalMasterCim(false)
                    submit(true)
                }}
                onCancel={() => { setOpenModalMasterCim(false); submit(false) }}
                onClose={() => setOpenModal(false)}
                showCancel={true}
                btnCancel={"Não"}
                btnConfirm={translate('confirm', 'general')}
            />
        </div >
    );
}

const mapStateToProps = (state) => {
    return {
        mission: state.loweringReducer.mission,
        order: state.loweringReducer.order,
        orders: state.loweringReducer.orders,
        groupOrder: state.loweringReducer.orderGroup,
        justifications: state.justificationReducer.justifications,
        filter: state.loweringReducer.filter,
        routes: state.pickingReducer.routes,
        areas: state.loweringReducer.areas,
        orderReceived: state.loweringReducer.orderReceived,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        unblockOrder: (orderId, callback) => {
            dispatch(LoweringService.unblock(orderId, false, callback));
        },
        confirmPicking: (orderItem, callback) => {
            dispatch(LoweringService.confirmPicking(orderItem, callback));
        },
        rePicking: (orderItem, areas, callback) => {
            dispatch(LoweringService.rePicking(orderItem, areas, callback));
        },
        leave: (orderGroupId, abandon, callback) => {
            dispatch(LoweringService.leave(orderGroupId, abandon, callback));
        },
        getNextOrder: (filter, callback) => {
            dispatch(LoweringService.getNextOrder(filter, callback));
        },
        setSelectedMission: (mission) => {
            dispatch(actionsLowering.selectMission(mission));
        },
        updateMissionStatus: (orderItemId, status) => {
            dispatch(actionsLowering.updateMissionStatus(orderItemId, status));
        },
        updateOrderStatus: (orderId, status) => {
            dispatch(actionsLowering.updateOrderStatus(orderId, status))
        },
        startOrderItem: (orderId, orderItemId, callback) => {
            dispatch(LoweringService.startOrderItem(orderId, orderItemId, callback));
        },
        setSelectedOrder: (order) => {
            dispatch(actionsLowering.selectOrder(order));
        },
        startOrder: (orderId, callback) => {
            dispatch(LoweringService.startOrder(orderId, callback));
        },
        updateQrCodeOrder: (orderId, filter, callback) => {
            dispatch(LoweringService.updateQrCodeOrder(orderId, filter, callback));
        },
        finalize: (data, callback) => {
            dispatch(LoweringService.finishOrderGroup(data, callback));
        },
        getRoutes: (filter, callback) => {
            dispatch(RoutePickingService.getRoutes(filter, callback));
        },
        finishDelivery: (idDolly, callback) => {
            dispatch(DeliveryService.FinishDollyDelivery(idDolly, callback));
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ListItemMissionDetail)));
